class Forms {
    static recaptchaLoaded = false;
    static recaptchaLoading = false;
    static recaptchaCallbacks = [];

    constructor() {
        this.formFields = document.querySelectorAll('input:not([name="s"]), textarea, select');
        this.init();
    }

    init() {
        if (!this.formFields.length) return;

        const onFirstFocus = () => Forms.loadScript();

        this.formFields.forEach(field => {
            field.addEventListener('focus', onFirstFocus, { once: true });
        });
    }

    static loadScript(callback) {
        if (Forms.recaptchaLoaded) {
            if (typeof callback === 'function') callback();
            return;
        }

        if (Forms.recaptchaLoading) {
            if (typeof callback === 'function') Forms.recaptchaCallbacks.push(callback);
            return;
        }

        Forms.recaptchaLoading = true;
        if (typeof callback === 'function') Forms.recaptchaCallbacks.push(callback);

        const script = document.createElement('script');
        // reCAPTCHA v3:
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(AppSettings.recaptchaSiteKey)}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            Forms.recaptchaLoaded = true;
            Forms.recaptchaLoading = false;

            Forms.recaptchaCallbacks.forEach(cb => typeof cb === 'function' && cb());
            Forms.recaptchaCallbacks = [];
        };

        script.onerror = () => {
            Forms.recaptchaLoading = false;
            console.error('Falha ao carregar o script do reCAPTCHA v3.');
            Forms.recaptchaCallbacks = [];
        };

        document.head.appendChild(script);
    }

    /**
     * Executa o reCAPTCHA v3, atualiza o campo hidden e dispara callback opcional.
     */
    static reloadCaptcha(action, fieldName = 'recaptcha_token', callback = null) {
        const exec = () => {
            const api = window.grecaptcha;

            if (!api) {
                console.warn('grecaptcha ainda não está disponível.');
                return;
            }

            api.ready(() => {
                api.execute(AppSettings.recaptchaSiteKey, { action })
                    .then(token => {
                        Forms.setToken(fieldName, token);
                        if (typeof callback === 'function') callback(token);
                    })
                    .catch(err => {
                        console.error('Erro ao executar reCAPTCHA v3:', err);
                    });
            });
        };

        Forms.loadScript(exec);
    }

    /**
     * No primeiro focus em algum campo do formulário, executa o reCAPTCHA
     * e remove o disabled do botão submit quando o token for válido.
     */
    static enableSubmitAfterRecaptchaValid(action, buttonSubmit, fieldName = 'recaptcha_token') {
        if (!buttonSubmit) return;

        const form = buttonSubmit.closest('form');
        if (!form) return;

        const fields = form.querySelectorAll(
            'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select'
        );
        if (!fields.length) return;

        let activated = false;

        const onFirstFocus = () => {
            if (activated) return;
            activated = true;

            Forms.reloadCaptcha(action, fieldName, (token) => {
                if (!token) return;
                buttonSubmit.removeAttribute('disabled');
            });
        };

        fields.forEach(field => {
            field.addEventListener('focus', onFirstFocus, { once: true });
        });
    }

    /**
     * Atualiza o valor do hidden com o token.
     */
    static setToken(fieldName, token) {
        const inputElement = document.querySelector(`input[name='${fieldName}']`);
        if (inputElement) inputElement.value = token;
    }

    /**
     * Inicialização simples para telas específicas (ex: homepage, contato, etc)
     */
    initializeReCaptcha(action = 'homepage') {
        Forms.reloadCaptcha(action, 'recaptcha_token');
    }

    /**
     * Mantida para compatibilidade, caso queira setar manualmente.
     */
    updateReCaptchaToken(token) {
        Forms.setToken('recaptcha_token', token);
    }
}

export default Forms;
window.reloadCaptcha = Forms.reloadCaptcha;
